@if (hasAttributes) {
  <hr>
  @if (title) {
    <p class="text-uppercase font-weight-bold"> {{ title }} </p>
  }
  <div class="icon-list-wrapper">
    @for (group of attributes | keyvalue; track group.key) {
      @for (attr of group.value; track attr.attributeId) {
        <app-product-attribute-icon
          [attribute]="attr"
          [isOpen]="activeAttributeId === (attr.attributeId || $index)"
          (onHoverOpen)="handleHoverOpen(attr.attributeId, $index)"
          (onHoverClose)="handleHoverClose()"
          (onClickToggle)="handleToggle(attr.attributeId, $index, $event)"
          (onClose)="handleClose($event)">
        </app-product-attribute-icon>
      }
    }
  </div>
  <hr>
}
